(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('musical-arrangement-type-ibq', {
            parent: 'entity',
            url: '/musical-arrangement-type-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalArrangementType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-typesibq.html',
                    controller: 'MusicalArrangementTypeIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalArrangementType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('musical-arrangement-type-ibq-detail', {
            parent: 'musical-arrangement-type-ibq',
            url: '/musical-arrangement-type-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalArrangementType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-detail.html',
                    controller: 'MusicalArrangementTypeIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalArrangementType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MusicalArrangementType', function($stateParams, MusicalArrangementType) {
                    return MusicalArrangementType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'musical-arrangement-type-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('musical-arrangement-type-ibq-detail.edit', {
            parent: 'musical-arrangement-type-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-dialog.html',
                    controller: 'MusicalArrangementTypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalArrangementType', function(MusicalArrangementType) {
                            return MusicalArrangementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-arrangement-type-ibq.new', {
            parent: 'musical-arrangement-type-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-dialog.html',
                    controller: 'MusicalArrangementTypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-type-ibq', null, { reload: 'musical-arrangement-type-ibq' });
                }, function() {
                    $state.go('musical-arrangement-type-ibq');
                });
            }]
        })
        .state('musical-arrangement-type-ibq.edit', {
            parent: 'musical-arrangement-type-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-dialog.html',
                    controller: 'MusicalArrangementTypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalArrangementType', function(MusicalArrangementType) {
                            return MusicalArrangementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-type-ibq', null, { reload: 'musical-arrangement-type-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-arrangement-type-ibq.delete', {
            parent: 'musical-arrangement-type-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-delete-dialog.html',
                    controller: 'MusicalArrangementTypeIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MusicalArrangementType', function(MusicalArrangementType) {
                            return MusicalArrangementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-type-ibq', null, { reload: 'musical-arrangement-type-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
